<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="field.var_name === 'tp_material_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            
          >
            <div>
              <treeselect
                :value="getValueInObject(field.var_name, field.input_type)"
                @input="
                  setValueInObject(field.var_name, $event, field.input_type)
                "
                :options="materialOptions"
                :load-options="loadMaterialOptions"
                :normalizer="materialOptionsNormalizer"
                :disabled="readOnly || field.disable"
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>
          <input-field
            v-else
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :automatic-label="field.has_automatic_label"
            :labelIsLocked="objectData.tp_label_locked"
            @generateLabel="getAutomaticLabel(autoLabelRequestData)"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
            @toggle-label-lock="changeLabelMode"
          />
        </template>
      </div>

      <div
        v-show="visibleTabs[activeTab].type === 'photos'"
        class="form tab-content"
      >
        <forms-photo-section
          :disabled="readOnly"
          :imagesList="imagesList"
          :previous-images="previousImages"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>

      <template v-show="visibleTabs[activeTab].type === 'module'">
        <specific-pole-tab
          v-show="
            visibleTabs[activeTab].label === 'Pole' ||
              visibleTabs[activeTab].code === 'pole_pole'
          "
          :pole-type="ownerServiceType"
          :disabled="readOnly"
          :object-data="objectData"
          @updateValue="setValueInObject($event.varName, $event.value)"
        />
        <pole-material-tab
          v-show="
            visibleTabs[activeTab].label === 'Material' ||
              visibleTabs[activeTab].code === 'pole_material'
          "
          :pole-type="ownerServiceType"
          :disabled="readOnly"
          :object-data="objectData"
          @updateValue="setValueInObject($event.varName, $event.value)"
        />
        <pole-terrain-tab
          v-show="
            visibleTabs[activeTab].label === 'Terrain' ||
              visibleTabs[activeTab].code === 'pole_terrain'
          "
          :pole-type="ownerServiceType"
          :disabled="readOnly"
          :object-data="objectData"
          @updateValue="setValueInObject($event.varName, $event.value)"
          :previous-images="previousImages"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
        <pole-angle-tab
          v-show="
            visibleTabs[activeTab].label === 'Angle' ||
              visibleTabs[activeTab].code === 'pole_angle'
          "
          :pole-type="ownerServiceType"
          :disabled="readOnly"
          :object-data="objectData"
          @updateValue="setValueInObject($event.varName, $event.value)"
        />
      </template>

      <asset-reservation-tab
        v-if="actionType !== 'create'"
        v-show="visibleTabs[activeTab].code === 'pole_asset_reservation'"
        :endpoint="form.endpoint"
        :object-uuid="objectData.tp_uuid"
        :disabled="readOnly"
        :fields="visibleTabs[activeTab].fields"
      />

      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Accessories'"
        :accessories-selected="accessoriesSelected"
        :accessories-selected-by-material-id="accessoriesSelectedByMaterialId"
        relation-family-id-select="pl"
        family-id="ac"
        :disabled="readOnly"
      />
      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Others'"
        :accessories-selected="othersSelected"
        :accessories-selected-by-material-id="othersSelectedByMaterialId"
        relation-family-id-select="pl"
        family-id="ot"
        :disabled="readOnly"
      />

      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import InputField from "../_Molecules/InputField";
import FormsPhotoSection from "../_SpecialTabs/Photos/PhotosForm";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import SpecificPoleTab from "../_SpecialTabs/PoleEffortModule/SpecificPoleTab";
import PoleMaterialTab from "../_SpecialTabs/PoleEffortModule/MaterialTab";
import PoleTerrainTab from "../_SpecialTabs/PoleEffortModule/TerrainTab";
import PoleAngleTab from "../_SpecialTabs/PoleEffortModule/AngleTab";
import { bus } from "@/main";
import AssetReservationTab from "@/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationTab";
import AccessoriesAndOthersTab from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "PoleForm",

  components: {
    AccessoriesAndOthersTab,
    AssetReservationTab,
    PoleAngleTab,
    PoleTerrainTab,
    PoleMaterialTab,
    SpecificPoleTab,
    DynamicObjectFormStructure,
    FormsPhotoSection,
    InputField,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    /**
     */
    linkObjectToPathway: {
      type: Object
    }
  },

  data() {
    return {
      poleEffortPrefix: "tp_pe_",
      listOfOrganizations: null
    };
  },

  computed: {
    autoLabelRequestData() {
      let request = {};
      let textGeom, projection;
      if (this.actionType === "create") {
        projection = 3857;
        textGeom = this.wkt;
      } else {
        projection = 4326;
        textGeom = this.dataReceived.node.nd_text_geom;
      }
      request = {
        layer: this.objectLayer,
        text_geom: textGeom,
        projection: projection
      };
      return request;
    },

    ownerServiceType() {
      let ownerID = this.objectData.tp_owner;
      if (ownerID) {
        let owner = this.listOfOrganizations.find(
          organization => organization.or_id == ownerID
        );
        if (owner && owner.or_service_type_code) {
          return owner.or_service_type_code;
        }
      }
      return "";
    },

    poleTypeEqualOther() {
      return this.objectData.tp_pole_type === "OTH";
    },

    hasRiser() {
      return this.objectData.tp_has_riser;
    },

    materialRequestQueryParameters() {
      return {
        material_family_id: "pl"
      };
    },

    poleEffortTabStatus() {
      let module = this.$store.getters.modulesStates.find(
        module => module.permission_name === "module_pole_effort"
      );
      return module && module.status;
    }
  },

  watch: {
    poleTypeEqualOther() {
      let varName = "tp_pole_type_other";
      let fields = this.form.tabs[0].fields;
      this.updateDependentFieldValueAndDisabledState(
        varName,
        this.poleTypeEqualOther,
        fields
      );
    },

    hasRiser() {
      let varName = "tp_number_subt_trans";
      let fields = this.form.tabs[0].fields;
      this.updateDependentFieldValueAndDisabledState(
        varName,
        this.hasRiser,
        fields
      );
    },

    "objectData.tp_material_id"(newID) {
      this.updateMaterialDependentFields(newID);
    },

    materialOptions() {
      if (this.materialOptions && this.objectData.tp_material_id) {
        this.updateMaterialDependentFields(this.objectData.tp_material_id);
      }
    }
  },

  mounted() {
    this.getListOfOrganizations();
  },

  methods: {
    getListOfOrganizations() {
      let listName = "list_organization";
      let storedList = this.$store.getters.getListOfOptionsByListName(
        listName,
        [],
        true
      );
      if (storedList) this.listOfOrganizations = storedList;
      else
        this.GET_LIST({
          listName: listName,
          code: [],
          includeDeleted: true
        }).then(list => {
          this.listOfOrganizations = list;
        });
    },

    tabIsVisible(tab) {
      let poleEffortTabsAreVisible = this.showPoleEffortTabs();

      switch (tab.code) {
        case "pole_pole":
        case "pole_material":
        case "pole_terrain":
        case "pole_angle":
          return poleEffortTabsAreVisible && this.poleEffortTabStatus;
        default:
          return true;
      }
    },

    tabIsEnabled(tab) {
      return !(
        tab.code === "pole_asset_reservation" && this.actionType === "create"
      );
    },

    showPoleEffortTabs() {
      let userHasPoleEffortModule = this.userHasModulePermission(
        "module_pole_effort"
      );

      let poleIsOfElectricalOrTelecomType =
        this.ownerServiceType === "ENERGY" ||
        this.ownerServiceType === "TELECOM";

      return userHasPoleEffortModule && poleIsOfElectricalOrTelecomType;
    },

    getDifferentVarName(varName) {
      if (varName.startsWith("pole_effort." + this.poleEffortPrefix)) {
        return varName.replace(this.poleEffortPrefix, "");
      }
      return false;
    },

    /**
     * Creates the pole.
     * If the user is creating tech points in bulk the form is only closed and the
     * dataToSend is emitted and if there is a nextForm value the corresponding form
     * is opened
     */
    createObject() {
      this.createDataToSend();

      if (this.$attrs.creatingBulkTP) {
        this.updateObjectLocalStorageData();
        this.closeForm();
        this.$emit("update-tech-point-data", this.dataToSend);
        if (this.$attrs.nextForm) {
          this.$emit("open-next-form");
        }
      } else {
        this.CREATE_OBJECTS({
          endpoint: this.form.endpoint,
          data: [this.dataToSend]
        })
          .then(technicalPointData => {
            if (this.linkObjectToPathway.split) {
              bus.$emit("reset-pathway-and-split-data");
            }

            this.objectData.tp_label = this.incrementLabelSequential(
              this.objectData.tp_label
            );

            this.finishObjectCreation();
            if (this.$attrs.nextForm) {
              this.$emit("open-next-form", {
                createdTechPointData: technicalPointData.data.data[0],
                techPointGeom: this.dataToSend.node.text_geom
              });
            }
          })
          .catch(error => {
            this.$toasted.global.toast_error(error.response.data.data);
            this.loadingSave = false;
          });
      }
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        status: this.objectData.tp_status,
        progress: this.objectData.tp_progress,
        physical_type: "A",
        technical_point_type: "A",
        logical_type: "T" //TODO - Remove when removed required from back-end
      };

      if (this.accessoriesSelected || this.othersSelected) {
        this.dataToSend.accessories = [];
        this.generateAccessoriesDataSend(this.accessoriesSelected);
        this.generateAccessoriesDataSend(this.othersSelected);
      }
      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }
      this.placeObjectDataInDataToSend();

      if (this.objectData.hasOwnProperty("pole_effort")) {
        this.includePoleEffortFields();
      }
    },

    includePoleEffortFields() {
      this.dataToSend.pole_effort = {};
      Object.keys(this.objectData.pole_effort).forEach(key => {
        let newKey = key;
        if (key.includes(this.poleEffortPrefix)) {
          newKey = key.replace(this.poleEffortPrefix, "");
        }
        this.dataToSend.pole_effort[newKey] = this.objectData.pole_effort[key];
      });
    },

    updateMaterialDependentFields(materialID) {
      this.accessoriesSelectedByMaterialId = [];
      this.othersSelectedByMaterialId = [];
      if (materialID && this.materialOptions) {
        let materialOption = this.materialOptions.find(
          material => material.sm_id === materialID
        );
        if (materialOption) {
          this.getStockMaterial(materialOption)
            .then(material => {
              if (material.others) {
                this.generateAccessoriesAndOthersSelected(
                  this.accessoriesSelectedByMaterialId,
                  this.othersSelectedByMaterialId,
                  material.others
                );
              }
              if (material.family_specific_fields) {
                this.setValueInObject(
                  "tp_pole_type",
                  material.family_specific_fields.smpl_pole_type
                );
                this.setValueInObject(
                  "tp_height",
                  material.family_specific_fields.smpl_height
                );
                this.setValueInObject(
                  "tp_class",
                  material.family_specific_fields.smpl_class
                );
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      } else {
        if (!this.dataReceived.tp_material_id) {
          this.setValueInObject("tp_pole_type", this.dataReceived.tp_pole_type);
          this.setValueInObject("tp_height", this.dataReceived.tp_height);
          this.setValueInObject("tp_class", this.dataReceived.tp_class);
        } else {
          this.setValueInObject("tp_pole_type", null);
          this.setValueInObject("tp_height", null);
          this.setValueInObject("tp_class", null);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/PoleForm.vue